export default [
  {
    name: 'FunnelsList',
    path: 'funnels',
    component: () => import('pages/funnels/FunnelsList.vue')
  }
]
